// Shared password-flow helpers, so the reset and change-password surfaces can't
// drift on the minimum length or on how backend errors are surfaced.
// PASSWORD_MIN_LEN mirrors backend core.security.PASSWORD_MIN_LEN (forge-20260615-001).
export const PASSWORD_MIN_LEN = 8;

// FastAPI error `detail` may be a string, a 422 validation array, or a dict —
// normalize to a human-readable string.
export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
